import sumBy from 'lodash/sumBy';
import type { PaxInfo } from '../../../types/api/v1/obt/air/air_search_response';

export function getTotalPaxNumForPaxInfo(paxInfo: PaxInfo[]): number {
  return sumBy(paxInfo, 'numPax') ?? 1;
}
